import { GenIcon } from '../helpers/IconBase.es.js';

const CartOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M18 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V8.5C4 8.10218 4.15804 7.72064 4.43934 7.43934C4.72064 7.15804 5.10218 7 5.5 7H18.5C18.8978 7 19.2794 7.15804 19.5607 7.43934C19.842 7.72064 20 8.10218 20 8.5V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M15.999 10.3001C15.9496 10.3002 15.9014 10.3151 15.8604 10.3427C15.8194 10.3703 15.7875 10.4094 15.7687 10.4551C15.75 10.5008 15.7452 10.551 15.7549 10.5994C15.7647 10.6479 15.7886 10.6923 15.8236 10.7272C15.8586 10.762 15.9031 10.7858 15.9516 10.7953C16.0001 10.8049 16.0503 10.7999 16.0959 10.7809C16.1415 10.762 16.1805 10.7299 16.2079 10.6888C16.2354 10.6477 16.25 10.5995 16.25 10.5501C16.25 10.5171 16.2435 10.4845 16.2309 10.4541C16.2182 10.4238 16.1997 10.3961 16.1764 10.3729C16.1531 10.3497 16.1254 10.3313 16.095 10.3188C16.0645 10.3063 16.0319 10.2999 15.999 10.3001",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8.04892 10.3001C7.99952 10.3002 7.95128 10.3151 7.9103 10.3427C7.86932 10.3703 7.83743 10.4094 7.81867 10.4551C7.7999 10.5008 7.79509 10.551 7.80485 10.5994C7.81461 10.6479 7.8385 10.6923 7.8735 10.7272C7.9085 10.762 7.95305 10.7858 8.00152 10.7953C8.04998 10.8049 8.1002 10.7999 8.14582 10.7809C8.19144 10.762 8.23043 10.7299 8.25786 10.6888C8.28528 10.6477 8.29992 10.5995 8.29992 10.5501C8.29992 10.5171 8.29342 10.4845 8.2808 10.4541C8.26817 10.4238 8.24967 10.3961 8.22635 10.3729C8.20303 10.3497 8.17535 10.3313 8.1449 10.3188C8.11445 10.3063 8.08184 10.2999 8.04892 10.3001",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8 7V6.75C8 5.75544 8.39509 4.80161 9.09835 4.09835C9.80161 3.39509 10.7554 3 11.75 3H12.25C12.7425 3 13.2301 3.097 13.6851 3.28545C14.14 3.47391 14.5534 3.75013 14.9017 4.09835C15.2499 4.44657 15.5261 4.85997 15.7145 5.31494C15.903 5.76991 16 6.25754 16 6.75V7",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { CartOutlined };
